// RailCard.tsx — right-rail card shell (Sprint 83, ADR-082).
// Icon-tile header + title + optional count chip + body. Port of the
// prototype's RailCard (home_sf.jsx); icon is an AntD node instead of inline SVG.
import React, { useId } from 'react';

export interface RailCardProps {
  /** Icon node (AntD icon) shown in the 28px tile. */
  icon: React.ReactNode;
  /** Tile background (color or gradient). Defaults to brand blue. */
  tone?: string;
  title: string;
  /** Optional count chip (e.g. unread / remaining). */
  count?: number;
  children: React.ReactNode;
}

export const RailCard: React.FC<RailCardProps> = ({
  icon,
  tone = 'var(--blue)',
  title,
  count,
  children,
}) => {
  // Sprint 116 (116.1) — each rail card is a labelled landmark region; the title
  // is a level-2 heading (sibling of the main-column cards under the page h1, no
  // skipped level). useId keeps the label association unique across rail cards.
  const titleId = `railcard-${useId().replace(/:/g, '')}`;
  return (
    <section className="railcard" aria-labelledby={titleId}>
      <div className="rch">
        <span className="ri" style={{ background: tone }}>{icon}</span>
        <h2 id={titleId}>{title}</h2>
        {count != null && <span className="cnt">{count}</span>}
      </div>
      <div className="rbody">{children}</div>
    </section>
  );
};

export default RailCard;
